<template>
  <div>
    <!-- BOC:[error] -->
    <AErrorV1 :api="api"></AErrorV1>
    <!-- EOC -->
    <!-- BOC:[form] -->
    <v-form ref="form" lazy-validation @submit.prevent="validate">
      <v-card>
        <v-card-title>Edit Option</v-card-title>
        <v-card-text>
          <template>
            <FormTextArea
              :value="form['translatableText']"
              label="Translatable Text"
              :rules="summaryRules"
              @input="form['translatableText'] = $event"
            />
          </template>
          <template>
            <FormImage
              :value="form['imageEN']"
              label="Image EN"
              @input="form['imageEN'] = $event"
            />
          </template>
          <template>
            <FormImage
              :value="form['imageMS']"
              label="Image MS"
              @input="form['imageMS'] = $event"
            />
          </template>
          <template>
            <FormImage
              :value="form['imageZH']"
              label="Image ZH"
              @input="form['imageZH'] = $event"
            />
          </template>
          <template>
            <FormAudio
              :value="form['audioEN']"
              label="Audio EN"
              @input="form['audioEN'] = $event"
            />
          </template>
          <template>
            <FormAudio
              :value="form['audioMS']"
              label="Audio MS"
              @input="form['audioMS'] = $event"
            />
          </template>
          <template>
            <FormAudio
              :value="form['audioZH']"
              label="Audio ZH"
              @input="form['audioZH'] = $event"
            />
          </template>
          <template>
            <FormRadio
              :value="form['isCorrect']"
              label="Correct Ansswer"
              @input="form['isCorrect'] = $event"
            />
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$router.go(-1)"> Cancel </v-btn>
          <v-btn color="primary" :loading="api.isLoading" @click="validate">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import FormImage from "@/components/Moderator/QuestionOption/FormImage";
import FormTextArea from "@/components/Moderator/QuestionOption/FormTextArea";
import FormAudio from "@/components/Moderator/QuestionOption/FormAudio";
import FormRadio from "@/components/Moderator/QuestionOption/FormRadio";

import axios from "axios";
import store from "../../../store";
import { mapState } from "vuex";
export default {
  props: ["data","self","url", "callbackSuccess"],
  components: {
    FormImage,
    FormTextArea,
    FormAudio,
    FormRadio
  },
  computed: mapState({
    school: (state) => state.school.data,
  }),
  data: () => ({
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
   
    //BOC:[form]
    form: {
      translatableText: '{"en":"Test Summary","ms":"Ringkasan Ujian","zh":"测试摘要"}',
      imageEN: null,
      imageMS: null,
      imageZH: null,
      audioEN: null,
      audioMS: null,
      audioZH: null,
      isCorrect: false
    },
    fields: [],
    rules: {},
    summaryRules:[],
    mobile: null,
    code: null,
    //EOC
  }),

  created() {
    //BOC:[api]
    this.api.url = this.url
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
      this.api.error = null;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.callbackSuccess(resp);
    };
    //EOC
  },
  mounted() {
    this.form.id = this.$route.params.id;
    this.form.translatableText = this.self.translatableText;
    this.form.isCorrect = this.self.isCorrect
    this.form.audioEN =JSON.parse(this.self.translatableVoiceover)['en'] && JSON.parse(this.self.translatableVoiceover)['en'].url ? JSON.parse(this.self.translatableVoiceover)['en'].url : null;
    this.form.audioZH =  JSON.parse(this.self.translatableVoiceover)['zh'] &&  JSON.parse(this.self.translatableVoiceover)['zh'].url ? JSON.parse(this.self.translatableVoiceover)['zh'].url : null;
    this.form.audioMS = JSON.parse(this.self.translatableVoiceover)['ms'] && JSON.parse(this.self.translatableVoiceover)['ms'].url ? JSON.parse(this.self.translatableVoiceover)['ms'].url : null;
    this.form.imageEN = JSON.parse(this.self.translatableImage)['en'] && JSON.parse(this.self.translatableImage)['en'].url ? JSON.parse(this.self.translatableImage)['en'].url : null
    this.form.imageMS = JSON.parse(this.self.translatableImage)['ms'] && JSON.parse(this.self.translatableImage)['ms'].url ? JSON.parse(this.self.translatableImage)['ms'].url : null
    this.form.imageZH = JSON.parse(this.self.translatableImage)['zh'] && JSON.parse(this.self.translatableImage)['zh'].url  ? JSON.parse(this.self.translatableImage)['zh'].url : null;
  },
  methods: {
    //BOC:[form]
    validate() {
      this.api.callbackReset();
      this.summaryRules = [(v) => !!v || "Option text is required"];

      if (this.$refs.form.validate()) {
          this.submit();
      } else {
        this.api.callbackError("Please check the form.");
      }
    },
    async submit() {
      // this.api.params = this.$_.clone(this.form);
      // this.$api.fetch(this.api);
      this.api.isLoading = true;
      const formData = new FormData();
      const token = "Bearer " + store.state.auth.data.Session.token;
      const config = {
        headers: { Authorization: token },
      };
      formData.append(
        "translatableText",
        this.form.translatableText
      );
      formData.append("id", this.form.id);
      formData.append("imageEN", this.form.imageEN);
      formData.append("imageMS", this.form.imageMS);
      formData.append("imageZH", this.form.imageZH);
      formData.append("audioEN", this.form.audioEN);
      formData.append("audioMS", this.form.audioMS);
      formData.append("audioZH", this.form.audioZH);
      formData.append("isCorrect", this.form.isCorrect);
try {
    // Make the API request
    const response = await axios.post(
     this.url,
      formData,
      config
    );

    this.api.isLoading = false;
    this.callbackSuccess(response.data);
  } catch (error) {
    this.api.isLoading = false;
    this.api.isLoading = false;
    this.api.isError = true;
    this.api.error = error;
  }
    },
    //EOC
  },
};
</script>

<style>
</style>